import { Injectable } from '@angular/core';
import { API_URL } from 'common/constants/url.constants';
import { AppMetaModel, AppModel } from 'common/models/pagemodels/appModel/app.model';
import { BaseMetaModel } from 'common/models/utilitymodels/base.model';
import { FormDataWidgetService } from 'common/services/core_services/form.data.widget.service';
import { SystemService } from 'common/services/core_services/system.service';
import { AppDataService } from 'common/services/data_services/appService/appService.service';
@Injectable({
    providedIn: 'root',
})
export class AppWidgetService extends FormDataWidgetService<AppModel> {
    constructor(public service: AppDataService, public systemService: SystemService) {
        super(service, systemService);
    }

    getDataOfAppState() {
        return new Promise((resolve, reject) => {
            this.service
                .getDataOfAppState()
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getMetaModel(): BaseMetaModel {
        return new AppMetaModel().getMetaModel();
    }

    getIPAddres(): Promise<string> {
        return new Promise((res, rej) => {
            this.service
                .getDataByUrl(API_URL.getClientIPAddress)
                .then((data) => {
                    res(data.ip);
                })
                .catch((err) => {
                    rej(err);
                });
        });
    }
}
